<template>
  <div
    class="container section-container"
    :class="{[`variant-${variant}`]: variant}"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    props: {
      variant: {
        type: String,
        default: 'normal'
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .section-container {
    padding-bottom: 80px;

    &.variant-gray {
      background: $sectionContainerGrayBg;
      background: $sectionContainerGrayBg;
    }

    &.fluid-x {
      padding-left: 0;
      padding-right: 0;
    }
  }
</style>
